// sharedData/Observable.js
import { sharedData } from "../sharedData/sharedData";

class EnhancedObservable {
  constructor(key) {
    this.key = key;
    this.subscribers = [];
    this.history = [];
  }

  subscribe(callback) {
    const currentValue = this.getValue();
    callback(currentValue);
    this.subscribers.push(callback);
    
    return () => {
      this.subscribers = this.subscribers.filter(sub => sub !== callback);
      // If last subscriber unmounts, clear history
      if (this.subscribers.length === 0) {
        this.clearHistory();
      }
    };
  }

  setValue(value, metadata = {}) {
    const current = this.getValue();
    const newEntry = {
      value,
      by: metadata.by,
      isEnhanced: metadata.isEnhanced || false,
      timestamp: Date.now()
    };

    // Block if enhanced by another owner
    if (current.isEnhanced && current.by !== metadata.by) {
      return { 
        success: false, 
        message: `Status controlled by ${current.by}`
      };
    }

    // Update history and notify
    this.history.push(newEntry);
    sharedData.set(this.key, newEntry);
    this.subscribers.forEach(cb => cb(newEntry));
    
    return { success: true };
  }

  getValue() {
    return sharedData.get(this.key) || { 
      value: "Not Available", 
      by: null, 
      isEnhanced: false 
    };
  }

  revert(ownerId) {
    const current = this.getValue();
    if (current.by === ownerId) {
      // Find previous valid entry
      const prevEntry = this.history
        .reverse()
        .find(entry => entry.by !== ownerId);
      
      if (prevEntry) {
        sharedData.set(this.key, prevEntry);
        this.subscribers.forEach(cb => cb(prevEntry));
      } else {
        this.clear();
      }
    }
  }

  clear() {
    sharedData.delete(this.key);
    this.history = [];
  }

  clearHistory() {
    this.history = [];
  }
}

export const diligenceTypeObservable = new EnhancedObservable("diligenceStatus");